import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

export const CHALLENGE_CUSTOMER_TYPE = {
  OPEN_TO_EVERYONE: 'OPEN_TO_EVERYONE',
  LIFE_BASE_USERS: 'LIFE_BASE_USERS',
} as const;

export type ChallengeCustomerType = ValueOfKey<typeof CHALLENGE_CUSTOMER_TYPE>;

export const humanizeChallengeCustomerType: Record<ChallengeCustomerType, string> = {
  [CHALLENGE_CUSTOMER_TYPE.OPEN_TO_EVERYONE]: 'Open to everyone',
  [CHALLENGE_CUSTOMER_TYPE.LIFE_BASE_USERS]: 'Nutrition users',
};

export const challengeCustomerTypeOptions: Option<ChallengeCustomerType | ''>[] = [
  ...Object.values(CHALLENGE_CUSTOMER_TYPE).map((type) => ({
    value: type,
    label: humanizeChallengeCustomerType[type],
  })),
];
